<template>
  <v-carousel
    cycle
    height="400"
    hide-delimiter-background
    show-arrows-on-hover
  >
    <v-carousel-item
      v-for="(person, i) in persons"
      :key="i"
    >
    <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
    <v-img
  
  max-height="350"
  max-width="550"
  :src="person.picture.large"
></v-img>
</v-row>
      
    </v-carousel-item>
  </v-carousel>
</template>
<script>
  import axios from "axios";

  export default {
    data () {
      return {
        colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
        url: "https://randomuser.me/api/",
        persons: []
      }
    },
    created() {
        
        this.getPersons()
    },
    methods: {
         getPersons() {
      axios
        .get(this.url + "?results=50")
        .then((result) => {
          console.log(result);
          this.persons = result.data.results;
        })
        .catch((error) => {
          console.log(error);
          this.error_mesage = true;
        });
    }
    }
  }
</script>